<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Assignment Order Association</h5>
      <br />
      <br />
      <div class="row" *ngIf="DataList_Schedules.length==0">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Assignment Order Number</label>
          <input [(ngModel)]="Filter_Letter" name="Filter_Letter" type="number" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="SubmitSchedulesRelative()" class="btn btn-success" style="margin-right: 5px;"><i
              class="fa fa-link"></i> Associate with Assignment Order</button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="row" *ngIf="DataList_Schedules.length>0">

        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="RemoveSchedulesRelative()" class="btn btn-danger" style="margin-right: 5px;"><i
              class="fa  fa-remove"></i> Delete Association </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>


      <div class="table-responsive" *ngIf="DataList_Schedules.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Letter Number</th>
              <th>Customer Name</th>
              <th>Date</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Schedules">
              <td>{{DataList_Schedules.indexOf(item)+1}}</td>
              <td>{{item.code2}}</td>
              <td>{{item.code}}</td>
              <td>{{item.customerName}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.clock}}</td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>